import { isValid, parseISO } from 'date-fns'

export const isValidISOString = (value: unknown): value is string =>
  typeof value === 'string' && isValid(parseISO(value))
